import { decimalSep, t } from "./i18n";

/**
 * Kompakte Zahlen-Formatierung für KPI-Tiles im deutschen Stil.
 *
 *      0 ..    999  → "0" .. "999"
 *  1.000 ..  9.999  → "1,5T"   (1 Dezimal, Tausend)
 * 10.000 .. 99.999  → "12T"    (ganze Zahl, Tausend)
 * 100.000 .. 999.999 → "123T"
 * 1.000.000 .. 9.999.999 → "1,2M"
 * 10.000.000 .. 99.999.999 → "12M"
 * 100.000.000 .. 999.999.999 → "123M"
 * ≥ 1.000.000.000 → "1,2Mrd"
 *
 * 1–3 Stellen sichtbarer Zahl + Einheit (de: T/M/Mrd, via t() übersetzt),
 * Dezimaltrennzeichen sprachabhängig. Auch im Wallboard-Modus aus 5 m
 * Entfernung sofort lesbar.
 */
export function formatCount(n: number): string {
  if (!Number.isFinite(n) || n < 0) return "—";
  if (n < 1000) return Math.floor(n).toString();
  return formatScaled(n, 1000, [t("T"), t("M"), t("Mrd")]);
}

/**
 * Datei-/Payload-Größe im binären Stil (1 KiB = 1024 B), Dezimaltrennzeichen
 * sprachabhängig. Beispiele: 900 → "900 B", 1536 → "1,5 KB",
 * 25 * 1024 * 1024 → "25 MB".
 */
export function formatBytes(n: number): string {
  if (!Number.isFinite(n) || n < 0) return "—";
  if (n < 1024) return `${Math.round(n)} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  const text = v < 10 ? v.toFixed(1).replace(".", decimalSep()) : Math.round(v).toString();
  return `${text} ${units[i]}`;
}

function formatScaled(n: number, base: number, units: string[]): string {
  let v = n;
  let unitIdx = -1;
  while (v >= base && unitIdx < units.length - 1) {
    v /= base;
    unitIdx += 1;
  }
  // Wenn weiterhin sehr groß → letzte Einheit erlauben dass v ≥ 1000 ist
  const unit = units[unitIdx];
  // 1 Dezimal solange v < 10, sonst Integer
  const text = v < 10 ? v.toFixed(1).replace(".", decimalSep()) : Math.floor(v).toString();
  return `${text}${unit}`;
}
